import RestService from '../services/rest';

const getUserInformIncomes = async () => {
    return RestService.getAuthenticated("account/report-income");
}

export default {
    getUserInformIncomes
}